const admin = {
  en: {
    translation: {
      certification: "Certification",
      certify_business: "Certify business",
      choose_advisor: "Choose ADVISOR that certified the business",
      button_text: "Certify business",
      input_label: "Select Advisor",
      certificator: "Certificator",
      business_certified_on: "Business certified on "
    }
  },
  it: {
    translation: {
      certification: "Certificazione",
      certify_business: "Certifica l'attività",
      choose_advisor: "Scegli l'ADVISOR che ha certificato l'attività",
      button_text: "Certifica struttura",
      input_label: "Seleziona Advisor",
      certificator: "Certificatore",
      business_certified_on: "Struttura certificata il "
    }
  }
};

export default admin;
